/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useContext } from "react";
import { AzureADContext } from "cms/auth/context/AzureADContext";

const useOrganization = () => {
    const context = useContext(AzureADContext);
    if (!context) {
        throw new Error("context must be used inside a provider");
    }
    return context.organization;
};
export default useOrganization;
